export const HTTP_METHOD = "http.method";
export const HTTP_URL = "http.url";
export const HTTP_HOST = "http.host";
export const HTTP_SCHEME = "http.scheme";
export const HTTP_STATUS_CODE = "http.status_code";
export const HTTP_USER_AGENT = "http.user_agent";
export const HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED =
  "http.response_content_length_uncompressed";
export const NET_PEER_PORT = "net.peer.port";
export const NET_PEER_NAME = "net.peer.name";
export const CLOUD_REGION = "cloud.region";
/** @deprecated Use DEPLOYMENT_ENVIRONMENT_NAME instead. */
export const DEPLOYMENT_ENVIRONMENT = "deployment.environment";
export const DEPLOYMENT_ENVIRONMENT_NAME = "deployment.environment.name";
export const DEPLOYMENT_ID = "deployment.id";
export const CLOUD_PROVIDER = "cloud.provider";
export const PROCESS_RUNTIME_NAME = "process.runtime.name";
export const VCS_REF_HEAD_NAME = "vcs.ref.head.name";
export const VCS_REF_HEAD_REVISION = "vcs.ref.head.revision";
export const VCS_REPOSITORY_NAME = "vcs.repository.name";
export const VCS_REPOSITORY_REF_REVISION = "vcs.repository.ref.revision";
/** @deprecated Use VCS_REPOSITORY_REF_REVISION instead. */
export const VCS_REPOSITORY_REF_VERSION = VCS_REPOSITORY_REF_REVISION;
export const FAAS_INVOKED_REGION = "faas.invoked_region";
export const FAAS_INVOCATION_ID = "faas.invocation_id";
export const SERVICE_NAME = "service.name";
export const SERVICE_VERSION = "service.version";
